import { observer } from 'mobx-react-lite';
import React from 'react';

import Loader from 'common/Loader';
import NoData from 'common/NoData';
import PageSizer from 'common/PageSizer';
import NotificationCustomizable from 'common/ToastError';

import MockDataToggle from './components/MockDataToggle';
import TimelineContainer from './components/TimelineContainer';
import TimelineFilters from './components/TimeLineFilter';
import { CREW_TIMELINE_TEXT } from './text';
import { useCrewTimeline } from './useCrewTimeline';

const CrewTimeline = observer(() => {
	const {
		isTimelineError,
		isTimelineLoading,
		isNothingFound,
		isReadyShowResult,
		errorText,
		timelineData,
		canNavigatePrevious,
		canNavigateNext,
		displayDays,
		setFilters,
		navigateToPreviousPeriod,
		navigateToNextPeriod,
		navigateToToday,
	} = useCrewTimeline();

	if (isTimelineError) {
		return (
			<PageSizer fullPage>
				<MockDataToggle />
				<TimelineFilters onFiltersSubmitted={setFilters} />
				<NoData mode="error" />
				<NotificationCustomizable
					isShown
					header={CREW_TIMELINE_TEXT.serverErrorText}
					label={errorText}
				/>
			</PageSizer>
		);
	}

	return (
		<PageSizer fullPage>
			<MockDataToggle />
			<TimelineFilters onFiltersSubmitted={setFilters} />
			{isReadyShowResult && (
				<TimelineContainer
					timelineData={timelineData}
					onPreviousPeriod={navigateToPreviousPeriod}
					onNextPeriod={navigateToNextPeriod}
					onToday={navigateToToday}
					canNavigatePrevious={canNavigatePrevious}
					canNavigateNext={canNavigateNext}
					displayDays={displayDays}
				/>
			)}
			{isNothingFound && <NoData mode="noresult" />}
			{isTimelineLoading && <Loader />}
		</PageSizer>
	);
});

export default CrewTimeline;
